// extracted by mini-css-extract-plugin
export default {"grid":"ProductItem_grid__d30cx","img":"ProductItem_img__aI0me","content":"ProductItem_content__gBFIW","details":"ProductItem_details__sGl14","list":"ProductItem_list__UVJlu"};